import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=30ecda75&lang=scss"
import "./App.vue?vue&type=style&index=1&id=30ecda75&scoped=true&lang=scss"

import exportComponent from "/home/deployer/pwa/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ecda75"]])

export default __exports__